<template>

 <v-layout>
    <v-container grid-list-md>
      <v-card>
          <v-card-title class="greyk lighten-4k">
               <h3>Payroll</h3>
          </v-card-title>

          <v-card-text>
              <v-layout row wrap>
                  
              </v-layout>
          </v-card-text>
      </v-card>
    </v-container>
    </v-layout>
    
</template>

<script>

export default{
    layout:'accounts',
     name: "payroll-view",
  metaInfo() {
    return { title: this.$t("payroll") };
  },
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/accountant/payroll/payroll.vue